<template>
    <ImportPricePlansForm
        submit-route="products.product-addons.plans.import.submit"
        cancel-route-name="products.product-addons.download-upload"
        :errors="errors"
    />
</template>

<script setup>
import ImportPricePlansForm from '~@/Components/Products/Products/ImportPricePlansForm.vue'

defineProps({
    errors: { type: Object, default: () => ({}) },
})
</script>
